import { useNavigate } from 'react-router-dom'
import { lumi } from '../lib/lumi'
import {FileText, CheckCircle, XCircle, DollarSign, PlusCircle, FileSignature, History, Settings, LogOut, MessageCircleDashed as MessageCircle, Bell, Receipt, MessageSquare, Calculator, TrendingUp, FileCheck, ClipboardCheck, CreditCard, Sparkles, FileBarChart, Headset, Copy, Trash2} from 'lucide-react'
import { useState, useEffect } from 'react'

export default function Dashboard() {
  const navigate = useNavigate()
  const [showNotifications, setShowNotifications] = useState(false)
  const [showSupportModal, setShowSupportModal] = useState(false)
  const [propostas, setPropostas] = useState<any[]>([])
  const [mostrarControlePropostas, setMostrarControlePropostas] = useState(false)

  useEffect(() => {
    const verificarAutenticacao = async () => {
      const user = lumi.auth.user
      if (!user) {
        console.log('Usuário não autenticado, redirecionando para login')
        navigate('/login', { replace: true })
        return
      }
      await carregarDados()
    }
    verificarAutenticacao()
  }, [navigate])

  const carregarDados = async () => {
    try {
      const user = lumi.auth.user
      const userId = user?.userId
      
      console.log('🔍 User object:', user)
      console.log('🔍 UserId extraído:', userId)
      
      if (!user || !userId) {
        console.log('Usuário não autenticado ou ID inválido')
        setPropostas([])
        return
      }

      console.log('Buscando propostas para userId:', userId)
      
      const resultPropostas = await lumi.entities.propostas.list({
        filter: { creator: userId },
        sort: { createdAt: -1 },
        limit: 100
      })
      
      console.log('Resultado da busca:', resultPropostas)
      setPropostas(resultPropostas?.list || [])
      console.log('Propostas carregadas:', resultPropostas?.list?.length || 0)
    } catch (error: any) {
      console.error('Erro ao carregar dados:', {
        message: error?.message || 'Erro desconhecido',
        name: error?.name || 'Error',
        stack: error?.stack
      })
      setPropostas([])
    }
  }

  const limparTodosDados = async () => {
    if (!confirm('⚠️ ATENÇÃO: Isso vai DELETAR PERMANENTEMENTE todas as suas propostas, contratos e dados. Esta ação NÃO pode ser desfeita. Deseja continuar?')) {
      return
    }
    
    if (!confirm('Tem certeza ABSOLUTA? Todos os dados serão perdidos para sempre!')) {
      return
    }
    
    try {
      const user = lumi.auth.user
      const userId = user?.userId
      
      if (!userId) {
        alert('Erro: usuário não identificado')
        return
      }
      
      // Buscar e deletar propostas
      try {
        const { list: minhasPropostas } = await lumi.entities.propostas.list({
          filter: { creator: userId },
          limit: 1000
        })
        
        if (minhasPropostas && minhasPropostas.length > 0) {
          await Promise.all(
            minhasPropostas.map(proposta => 
              lumi.entities.propostas.delete(proposta._id)
            )
          )
        }
      } catch (error) {
        console.error('Erro ao deletar propostas:', error)
      }
      
      // Buscar e deletar contratos
      try {
        const { list: meusContratos } = await lumi.entities.contratos.list({
          filter: { creator: userId },
          limit: 1000
        })
        
        if (meusContratos && meusContratos.length > 0) {
          await Promise.all(
            meusContratos.map(contrato => 
              lumi.entities.contratos.delete(contrato._id)
            )
          )
        }
      } catch (error) {
        console.error('Erro ao deletar contratos:', error)
      }
      
      await carregarDados()
      alert('✅ Todos os dados foram limpos com sucesso!')
    } catch (error) {
      console.error('Erro ao limpar dados:', error)
      alert('Erro ao limpar dados. Tente novamente.')
    }
  }

  const handleLogout = async () => {
    await lumi.auth.signOut()
  }

  const propostasAceitas = propostas.filter(p => p.status === 'aceita')
  const propostasPerdidas = propostas.filter(p => p.status === 'perdida')
  
  const totalFechado = propostasAceitas.reduce((total, p) => {
    return total + (parseFloat(p.valorFechado || p.valor) || 0)
  }, 0)

  const stats = [
    { label: 'Propostas criadas', value: propostas.length.toString(), icon: FileText, color: 'bg-blue-50 text-blue-600' },
    { 
      label: 'Propostas aceitas', 
      value: propostasAceitas.length.toString(), 
      icon: CheckCircle, 
      color: 'bg-green-50 text-green-600'
    },
    { label: 'Propostas perdidas', value: propostasPerdidas.length.toString(), icon: XCircle, color: 'bg-red-50 text-[#8B0000]' },
    { label: 'Total fechado', value: `R$ ${totalFechado.toFixed(2)}`, icon: DollarSign, color: 'bg-emerald-50 text-emerald-600' },
  ]



  const [editandoProposta, setEditandoProposta] = useState<string | null>(null)
  const [valorFechado, setValorFechado] = useState('')

  const marcarStatus = async (propostaId: string, novoStatus: 'aceita' | 'perdida', valorGanho?: string) => {
    try {
      const updateData: any = {
        status: novoStatus,
        updatedAt: new Date().toISOString()
      }
      
      if (novoStatus === 'aceita' && valorGanho) {
        updateData.valorFechado = valorGanho
        updateData.dataAceite = new Date().toISOString()
      }

      await lumi.entities.propostas.update(propostaId, updateData)
      await carregarDados()
      setEditandoProposta(null)
      setValorFechado('')
      alert(`Proposta marcada como ${novoStatus === 'aceita' ? 'fechada' : 'perdida'}!`)
    } catch (error) {
      console.error('Erro ao atualizar proposta:', error)
      alert('Erro ao atualizar proposta')
    }
  }

  const excluirProposta = async (propostaId: string) => {
    if (!confirm('Tem certeza que deseja excluir esta proposta? Esta ação não pode ser desfeita.')) {
      return
    }
    try {
      await lumi.entities.propostas.delete(propostaId)
      await carregarDados()
      alert('Proposta excluída com sucesso!')
    } catch (error) {
      console.error('Erro ao excluir proposta:', error)
      alert('Erro ao excluir proposta')
    }
  }

  if (mostrarControlePropostas) {
    const propostasPendentes = propostas.filter(p => p.status === 'criada')
    
    return (
      <div className="min-h-screen bg-gray-50">
        <header className="bg-white border-b border-gray-200">
          <div className="max-w-7xl mx-auto px-3 sm:px-4 py-3">
            <div className="flex items-center justify-between">
              <h1 className="text-lg sm:text-xl font-bold text-[#8B0000]">Gerenciar Propostas</h1>
              <button
                onClick={() => setMostrarControlePropostas(false)}
                className="px-3 py-2 text-sm text-gray-600 hover:text-gray-900 font-medium"
              >
                Voltar
              </button>
            </div>
          </div>
        </header>

        {/* Modal de Suporte */}
      {showSupportModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4">
          <div className="bg-white rounded-lg p-6 max-w-sm w-full">
            <h3 className="font-bold text-lg mb-4 text-gray-900">Central de Suporte</h3>
            
            {/* WhatsApp */}
            <a 
              href="https://wa.me/558199387-9157" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white p-4 rounded-lg mb-3 transition-colors"
            >
              <MessageCircle size={24} />
              <div>
                <p className="font-semibold">WhatsApp</p>
                <p className="text-sm">+55 81 99387-9157</p>
              </div>
            </a>
            
            {/* E-mail */}
            <div className="bg-gray-100 p-4 rounded-lg mb-4">
              <p className="text-sm text-gray-600 mb-2 font-semibold">E-mail</p>
              <div className="flex items-center gap-2">
                <input 
                  value="suporte.nexias.unovalinks@gmail.com" 
                  readOnly 
                  className="flex-1 text-sm bg-white p-2 rounded border border-gray-300" 
                />
                <button 
                  onClick={() => {
                    navigator.clipboard.writeText('suporte.nexias.unovalinks@gmail.com')
                    alert('E-mail copiado!')
                  }} 
                  className="bg-[#8B0000] hover:bg-[#6B0000] text-white px-3 py-2 rounded transition-colors flex items-center gap-1"
                >
                  <Copy size={16} />
                </button>
              </div>
            </div>
            
            <button 
              onClick={() => setShowSupportModal(false)} 
              className="w-full bg-gray-200 hover:bg-gray-300 py-2 rounded transition-colors font-medium"
            >
              Fechar
            </button>
          </div>
        </div>
      )}

      <main className="max-w-7xl mx-auto px-3 sm:px-4 py-4">
          {/* Propostas Pendentes */}
          <div className="mb-6">
            <h2 className="text-base font-bold text-gray-900 mb-3 flex items-center gap-2">
              <FileText size={20} className="text-blue-600" />
              Propostas Criadas - Aguardando Definição ({propostasPendentes.length})
            </h2>
            {propostasPendentes.length === 0 ? (
              <div className="bg-white rounded-lg p-6 text-center border border-gray-100">
                <p className="text-sm text-gray-500">Nenhuma proposta pendente</p>
              </div>
            ) : (
              <div className="space-y-3">
                {propostasPendentes.map(proposta => (
                  <div key={proposta._id} className="bg-white rounded-lg p-4 shadow-sm border border-gray-100">
                    <div className="flex items-start justify-between mb-3">
                      <div className="flex-1">
                        <h3 className="text-sm font-bold text-gray-900 mb-2">{proposta.servicoOferecido}</h3>
                        <div className="space-y-1 text-xs text-gray-600">
                          <p><span className="font-semibold">Cliente:</span> {proposta.nomeCliente}</p>
                          <p><span className="font-semibold">Valor proposto:</span> R$ {proposta.valor}</p>
                          <p><span className="font-semibold">Criada em:</span> {new Date(proposta.createdAt).toLocaleDateString('pt-BR')}</p>
                        </div>
                      </div>
                      <button
                        onClick={() => excluirProposta(proposta._id)}
                        className="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                        title="Excluir proposta"
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                    
                    {editandoProposta === proposta._id ? (
                      <div className="space-y-2">
                        <input
                          type="text"
                          value={valorFechado}
                          onChange={(e) => setValorFechado(e.target.value)}
                          placeholder="Valor fechado (ex: 5000.00)"
                          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg"
                        />
                        <div className="flex gap-2">
                          <button
                            onClick={() => marcarStatus(proposta._id, 'aceita', valorFechado)}
                            className="flex-1 bg-green-600 text-white px-3 py-2 rounded-lg text-xs font-semibold hover:bg-green-700"
                          >
                            Confirmar Fechamento
                          </button>
                          <button
                            onClick={() => {
                              setEditandoProposta(null)
                              setValorFechado('')
                            }}
                            className="px-3 py-2 bg-gray-200 text-gray-700 rounded-lg text-xs font-semibold hover:bg-gray-300"
                          >
                            Cancelar
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="flex gap-2">
                        <button
                          onClick={() => {
                            setEditandoProposta(proposta._id)
                            setValorFechado(proposta.valor)
                          }}
                          className="flex-1 bg-green-600 text-white px-3 py-2 rounded-lg text-xs font-semibold hover:bg-green-700 flex items-center justify-center gap-1"
                        >
                          <CheckCircle size={16} />
                          Fechada
                        </button>
                        <button
                          onClick={() => marcarStatus(proposta._id, 'perdida')}
                          className="flex-1 bg-[#8B0000] text-white px-3 py-2 rounded-lg text-xs font-semibold hover:bg-[#6B0000] flex items-center justify-center gap-1"
                        >
                          <XCircle size={16} />
                          Perdida
                        </button>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Aceitas */}
          <div className="mb-6">
            <h2 className="text-base font-bold text-gray-900 mb-3 flex items-center gap-2">
              <CheckCircle size={20} className="text-green-600" />
              Propostas Fechadas ({propostasAceitas.length})
            </h2>
            {propostasAceitas.length === 0 ? (
              <div className="bg-white rounded-lg p-6 text-center border border-gray-100">
                <p className="text-sm text-gray-500">Nenhuma proposta fechada</p>
              </div>
            ) : (
              <div className="space-y-3">
                {propostasAceitas.map(proposta => (
                  <div key={proposta._id} className="bg-white rounded-lg p-4 shadow-sm border border-gray-100">
                    <div className="flex items-start justify-between">
                      <div className="flex-1">
                        <h3 className="text-sm font-bold text-gray-900 mb-2">{proposta.servicoOferecido}</h3>
                        <div className="space-y-1 text-xs text-gray-600">
                          <p><span className="font-semibold">Cliente:</span> {proposta.nomeCliente}</p>
                          <p><span className="font-semibold">Valor fechado:</span> R$ {proposta.valorFechado || proposta.valor}</p>
                          <p><span className="font-semibold">Fechada em:</span> {proposta.dataAceite ? new Date(proposta.dataAceite).toLocaleDateString('pt-BR') : 'N/A'}</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        <div className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs font-semibold">
                          Fechada
                        </div>
                        <button
                          onClick={() => excluirProposta(proposta._id)}
                          className="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                          title="Excluir proposta"
                        >
                          <Trash2 size={16} />
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Perdidas */}
          <div>
            <h2 className="text-base font-bold text-gray-900 mb-3 flex items-center gap-2">
              <XCircle size={20} className="text-[#8B0000]" />
              Propostas Perdidas ({propostasPerdidas.length})
            </h2>
            {propostasPerdidas.length === 0 ? (
              <div className="bg-white rounded-lg p-6 text-center border border-gray-100">
                <p className="text-sm text-gray-500">Nenhuma proposta perdida</p>
              </div>
            ) : (
              <div className="space-y-3">
                {propostasPerdidas.map(proposta => (
                  <div key={proposta._id} className="bg-white rounded-lg p-4 shadow-sm border border-gray-100">
                    <div className="flex items-start justify-between">
                      <div className="flex-1">
                        <h3 className="text-sm font-bold text-gray-900 mb-2">{proposta.servicoOferecido}</h3>
                        <div className="space-y-1 text-xs text-gray-600">
                          <p><span className="font-semibold">Cliente:</span> {proposta.nomeCliente}</p>
                          <p><span className="font-semibold">Valor:</span> R$ {proposta.valor}</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        <div className="bg-red-100 text-[#8B0000] px-2 py-1 rounded-full text-xs font-semibold">
                          Perdida
                        </div>
                        <button
                          onClick={() => excluirProposta(proposta._id)}
                          className="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                          title="Excluir proposta"
                        >
                          <Trash2 size={16} />
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </main>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Modal de Suporte */}
      {showSupportModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4">
          <div className="bg-white rounded-lg p-6 max-w-sm w-full">
            <h3 className="font-bold text-lg mb-4 text-gray-900">Central de Suporte</h3>
            
            {/* WhatsApp */}
            <a 
              href="https://wa.me/558199387-9157" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white p-4 rounded-lg mb-3 transition-colors"
            >
              <MessageCircle size={24} />
              <div>
                <p className="font-semibold">WhatsApp</p>
                <p className="text-sm">+55 81 99387-9157</p>
              </div>
            </a>
            
            {/* E-mail */}
            <div className="bg-gray-100 p-4 rounded-lg mb-4">
              <p className="text-sm text-gray-600 mb-2 font-semibold">E-mail</p>
              <div className="flex items-center gap-2">
                <input 
                  value="suporte.nexias.unovalinks@gmail.com" 
                  readOnly 
                  className="flex-1 text-sm bg-white p-2 rounded border border-gray-300" 
                />
                <button 
                  onClick={() => {
                    navigator.clipboard.writeText('suporte.nexias.unovalinks@gmail.com')
                    alert('E-mail copiado!')
                  }} 
                  className="bg-[#8B0000] hover:bg-[#6B0000] text-white px-3 py-2 rounded transition-colors flex items-center gap-1"
                >
                  <Copy size={16} />
                </button>
              </div>
            </div>
            
            <button 
              onClick={() => setShowSupportModal(false)} 
              className="w-full bg-gray-200 hover:bg-gray-300 py-2 rounded transition-colors font-medium"
            >
              Fechar
            </button>
          </div>
        </div>
      )}

      <header className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <img 
                src="https://static.lumi.new/94/94387bd69277769ec0567b4f6dbc1e0e.webp" 
                alt="Logo" 
                className="h-8 w-auto"
              />
              <div>
                <h1 className="text-lg font-bold text-[#8B0000]">Unovalinks</h1>
                <p className="text-xs text-gray-600">Transforme propostas em dinheiro</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={() => setShowSupportModal(true)}
                className="p-2 hover:bg-blue-50 rounded-lg transition-colors"
                title="Suporte"
              >
                <Headset size={20} className="text-gray-600" />
              </button>
              
              <button
                onClick={limparTodosDados}
                className="p-2 hover:bg-red-50 rounded-lg transition-colors"
                title="Limpar todos os dados"
              >
                <Trash2 size={20} className="text-red-600" />
              </button>
              
              <div className="relative">
                <button 
                  onClick={() => setShowNotifications(!showNotifications)}
                  className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                >
                  <Bell size={20} className="text-gray-600" />
                </button>
                
                {showNotifications && (
                  <div className="absolute right-0 mt-2 w-72 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
                    <div className="p-3 border-b border-gray-200">
                      <h3 className="font-semibold text-gray-900 text-sm">Notificações</h3>
                    </div>
                    <div className="p-8 text-center">
                      <Bell size={40} className="mx-auto text-gray-300 mb-2" />
                      <p className="text-sm text-gray-500">Nenhuma notificação</p>
                    </div>
                  </div>
                )}
              </div>

              <button 
                onClick={handleLogout}
                className="flex items-center gap-1 px-3 py-2 text-sm text-[#8B0000] hover:bg-red-50 rounded-lg transition-colors font-medium"
              >
                <LogOut size={18} />
                <span className="hidden sm:inline">Sair</span>
              </button>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-3 sm:px-4 py-4">
        {/* Stats Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6">
          {stats.map((stat, index) => (
            <div 
              key={index} 
              className="bg-white rounded-lg p-4 shadow-sm border border-gray-100"
            >
              <div className={`w-10 h-10 rounded-lg ${stat.color} flex items-center justify-center mb-3`}>
                <stat.icon size={20} />
              </div>
              <div className="text-xl font-bold text-gray-900 mb-1">{stat.value}</div>
              <div className="text-xs text-gray-600">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Ações Principais */}
        <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-100 mb-6">
          <h2 className="text-base font-bold text-gray-900 mb-3">Ações Principais</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            <button
              onClick={() => navigate('/criar-proposta')}
              className="bg-[#8B0000] hover:bg-[#6B0000] px-4 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2 text-white text-sm"
            >
              <PlusCircle size={18} />
              Criar nova proposta
            </button>
            <button
              onClick={() => navigate('/criar-contrato')}
              className="bg-[#8B0000] hover:bg-[#6B0000] px-4 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2 text-white text-sm"
            >
              <FileSignature size={18} />
              Criar novo contrato
            </button>
            <button
              onClick={() => setMostrarControlePropostas(true)}
              className="bg-[#8B0000] hover:bg-[#6B0000] px-4 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2 text-white text-sm"
            >
              <FileCheck size={18} />
              Gerenciar Propostas
            </button>
            <button
              onClick={() => navigate('/comprovante-pagamento')}
              className="bg-[#8B0000] hover:bg-[#6B0000] px-4 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2 text-white text-sm"
            >
              <Receipt size={18} />
              Comprovante de Pagamento
            </button>
          </div>
        </div>

        {/* Assistente */}
        <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-100 mb-6">
          <h2 className="text-base font-bold text-gray-900 mb-3">Assistente</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            <button
              onClick={() => navigate('/nota-fiscal')}
              className="bg-gray-100 hover:bg-gray-200 px-4 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2 text-gray-900 text-sm"
            >
              <Receipt size={18} />
              Nota Fiscal
            </button>
            <button
              onClick={() => navigate('/analise-vendas')}
              className="bg-gray-100 hover:bg-gray-200 px-4 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2 text-gray-900 text-sm"
            >
              <TrendingUp size={18} />
              Análise de Vendas
            </button>
            <button
              onClick={() => navigate('/funil-vendas')}
              className="bg-gray-100 hover:bg-gray-200 px-4 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2 text-gray-900 text-sm"
            >
              <Sparkles size={18} />
              Funil de Vendas
            </button>
            <button
              onClick={() => navigate('/calendario-entregas')}
              className="bg-gray-100 hover:bg-gray-200 px-4 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2 text-gray-900 text-sm"
            >
              <ClipboardCheck size={18} />
              Calendário de Entregas
            </button>
          </div>
        </div>
      </main>
    </div>
  )
}
